import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CookiesService } from '@app/core/services/cookies.service';
import { pageAnimation } from '@app/shared/animations/page-animations';
import { Background } from '@app/shared/models/background';
import { Customization } from '@app/shared/models/customization';
import Plyr, { Options, SourceInfo } from 'plyr';
import { Constant } from 'src/constant';

@Component({
  selector: 'app-smash-previewer-customization',
  templateUrl: './smash-previewer-customization.component.html',
  styleUrls: ['./smash-previewer-customization.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    pageAnimation
  ]
})
export class SmashPreviewerCustomizationComponent implements OnInit, OnChanges {
  displayTooltip: boolean;

  @Input() url: string;
  @Input() customization: Customization;
  @Input() customizationLoading: boolean;
  @Input() customizationError: any;
  // receiver or sender
  @Input() customizationAim: "receiver" | "sender";
  @Input() displayType?: string;
  @Input() position: string;
  @Input() delay = 1000;
  @Input() tooltipDisplayed = true;
  @Input() componentSource: string;
  @Input() playerId?: string = undefined;

  loadingSpinnerDisplayed = false;

  logoFallback = {
    sourceUrl: '../../../../assets/img/smash-logo/png/icono-chip-full-white.png',
    thumbnail: '../../../../assets/img/smash-logo/png/icono-chip-full-white.png',
    type: 'Image',
  };

  playerSource: SourceInfo;
  playerOptions: Options;

  constructor(
    private cookiesService: CookiesService,
    private cd: ChangeDetectorRef) { }

  ngOnInit(): void { }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes?.customization?.currentValue) {
      if (this.customization?.background?.type === 'Vimeo' || this.customization?.background?.type === 'Youtube') {
        this.playerSource = this.buildPlayerSource(this.customization.background);
        this.playerOptions = this.buildPlayerOptions(this.customization.background);
        this.cd.markForCheck();
      }
    }
  }

  hideLoadingSpinner() {
    setTimeout(() => {
      this.loadingSpinnerDisplayed = false;
      this.cd.markForCheck();
    }, 1000);
  }

  displayLoadingSpinner() {
    this.loadingSpinnerDisplayed = true;
    this.cd.markForCheck();
  }

  // Player
  buildPlayerSource(background: Background): SourceInfo {
    const source: SourceInfo = {
      sources: [{
        src: background.sourceId,
        provider: Constant.videoProviders[background.type],
      }],
      type: 'video' as Plyr.MediaType,
    }
    return source;
  }

  buildPlayerOptions(item: any): Options {
    const options: Options = {
      autoplay: true,
      clickToPlay: false,
      controls: [],
      disableContextMenu: true,
      muted: true,
      storage: { enabled: false },
      loop: { active: true },
    };

    if (item.type === 'Youtube') {
      options.youtube = { noCookie: true, rel: 0, controls: 0, autohide: 1, showinfo: 0, iv_load_policy: 3, modestbranding: 1 };
    }

    if (item.type === 'Vimeo') {
      options.vimeo = { dnt: 1, byline: 0, title: 0, background: 1, loop: 1, autoplay: 1 };
    }

    return options;
  }
}
